module.exports = __webpack_public_path__ + "img/stolik-asysty-1.d6f3d2be.png";